import BaseStyle from '@primevue/core/base/style';

var FocusTrapStyle = BaseStyle.extend({
  name: 'focustrap-directive'
});

export { FocusTrapStyle as default };
//# sourceMappingURL=index.mjs.map
